module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/rainbow.26bce813.png";